import React, {useEffect, useState} from "react";
import "./Cat_Clothing.scss";
import {Header_Clothing} from "../Component_Clothing/Header_Clothing/Header_Clothing";
import {useHistory, useParams} from "react-router-dom";
import {Cat_Card_Clothing} from "../Component_Clothing/Cat_Card_Clothing/Cat_Card_Clothing";
import {clothing_cats} from "../Services_Clothing";

function Cat_Clothing() {

    //hooks
    const history = useHistory();
    const {merchantId} = useParams();

    //states
    const [data,set_data] = useState([]);

    //life
    useEffect(()=>{
        getCats()
    },[])

    // func
    const getCats = async () => {
        const response = await clothing_cats(merchantId);
        set_data(response.data)
    }



    return(
        <div className="cat-clothing-container">
            <Header_Clothing/>
            {data.map(item=>{
                return(
                    <Cat_Card_Clothing merchantId={merchantId} item={item}/>
                )
            })}
        </div>
    )

}
export {Cat_Clothing}
